module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none",
      "color": "black"
    },
    attrs: {
      "to": {
        path: '/Facdash/'
      }
    }
  }, [_c('v-btn', {
    staticClass: "px-0 pb-0 pt-2 ml-0",
    attrs: {
      "small": "",
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("keyboard_backspace")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    on: {
      "click": _vm.downoadAsPdf
    }
  }, [_vm._v("Download As Pdf")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "id": "pdf_report"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 title"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-left pt-2"
  }, [_vm._v(_vm._s(_vm.lReport.comm_name) + " - FM Daily Report (" + _vm._s(_vm.lReport.rep_date) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-right"
  }, [_c('img', {
    attrs: {
      "height": "30",
      "src": require("../../static/img/logo/integra_logo.png")
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-top": "1px solid black"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Attendance: " + _vm._s(_vm.lReport.attAve ? _vm.lReport.attAve : 0) + "% (" + _vm._s(_vm.lReport.tot_present + (_vm.lReport.tot_ot ? ' + ' + _vm.lReport.tot_ot : '') + '/' + _vm.lReport.tot_staff) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', _vm._l((_vm.lReport.roleCat), function(item, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "pa-0",
      style: (i > 0 ? 'border-top: 1px solid black;border-right: 1px solid black;border-bottom: 1px solid black;' : 'border-right: 1px solid black;border-left: 1px solid black;border-bottom: 1px solid black;border-top: 1px solid black;')
    }, [_c('div', {
      staticClass: "text-xs-center py-2",
      staticStyle: {
        "font-size": "12px",
        "background-color": "#215868",
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.lReport.attHeader.filter(function (rec) { return rec.role_cat === item; }),
        "items": _vm.attList.filter(function (rec) { return rec.role_cat === item; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(row) {
          return [_c('tr', _vm._l((row.headers[0].attHead), function(header, k) {
            return _c('th', {
              key: k,
              staticClass: "primary white--text pa-0"
            }, [_vm._v("\n                        " + _vm._s(header.short_form) + "\n                      ")])
          }), 0)]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "text-xs-center"
          }, _vm._l((props.item.attendance), function(att, k) {
            return _c('td', {
              key: k,
              staticClass: "pa-0",
              staticStyle: {
                "font-size": "12px"
              }
            }, [_vm._v("\n                        " + _vm._s(att.tot_present) + "\n                        "), (att.tot_wo || att.tot_holiday || att.tot_leave || att.tot_absent || att.tot_hd) ? _c('span', [_c('br')]) : _vm._e(), _vm._v(" "), (att.tot_wo) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' W' + att.tot_wo))]) : _vm._e(), _vm._v(" "), (att.tot_holiday) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' H' + att.tot_holiday))]) : _vm._e(), _vm._v(" "), (att.tot_leave) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' L' + att.tot_leave))]) : _vm._e(), _vm._v(" "), (att.tot_absent) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' A' + att.tot_absent))]) : _vm._e(), _vm._v(" "), (att.tot_hd) ? _c('span', {
              staticStyle: {
                "font-size": "9px"
              }
            }, [_vm._v(_vm._s(' HD' + att.tot_hd))]) : _vm._e()])
          }), 0)]
        }
      }], null, true)
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption pl-1 text-xs-left",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  NOTE: Attendance % includes weekly offs(W), holidays(H) and leaves(L)\n                ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption pr-1 text-xs-right",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  X+Y/Z where X total present+HD, Y is OT+S, Z is total number of staff\n                ")])])], 1)], 1), _vm._v(" "), (_vm.lReport.remark_attendance) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_attendance) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Compliance")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("COMPLIANCE STATUS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #4caf50",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#4caf50"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.active))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#4caf50"
    }
  }, [_vm._v("Active")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #ff9800",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#ff9800"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.expiring))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff9800"
    }
  }, [_vm._v("Expiring Soon")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #f44336",
      "border-radius": "4px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#f44336"
    }
  }, [_vm._v(_vm._s(_vm.complianceData.expired))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#f44336"
    }
  }, [_vm._v("Expired")])])])], 1), _vm._v(" "), (_vm.complianceData.total > 0) ? _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("\n                      Total Compliances: " + _vm._s(_vm.complianceData.total) + "\n                    ")])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.expiredComplianceList.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#f44336",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("EXPIRED COMPLIANCES")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "200px"
    }
  }, [_c('span', [_vm._v("Compliance Name")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "150px"
    }
  }, [_c('span', [_vm._v("Category")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "150px"
    }
  }, [_c('span', [_vm._v("Subcategory")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Category Type")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Cost")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "primary white--text text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "width": "120px"
    }
  }, [_c('span', [_vm._v("Expired At")])])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.expiredComplianceList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.compliance_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.category_name || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.subcategory_name || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.compliance_type || '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.cost ? '₹' + props.item.cost.toLocaleString() : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "120px"
          }
        }, [_vm._v(_vm._s(props.item.valid_to ? _vm.handy.formatDate(props.item.valid_to) : '-'))])])]
      }
    }], null, false, 3303308925)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Power Management")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("CONSUMPTION")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("EB")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.eb_unit ? _vm.lReport.eb_unit.toFixed(2) : '0') + " units")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mt-0 primary white--text py-4",
    staticStyle: {
      "font-size": "12px",
      "height": "78px"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('span', [_vm._v("DG")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center py-4",
    attrs: {
      "xs8": ""
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lReport.dg_unit) + " units")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    }
  }, [_vm._v("DISTRIBUTION (UNITS)")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powercons"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 py-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_powergenset"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_powergenset"
    }
  })])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DG SUMMARY")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.gensetHead), function(genset, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(genset.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.gensetList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.genset_nm ? props.item.genset_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.units_cons ? props.item.units_cons : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.level ? props.item.level + '%' : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.run_hrs ? props.item.run_hrs : '-'))])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black",
      "border-bottom": "1px solid black",
      "border-right": "1px solid black"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("DIESEL PURCHASE & STOCK")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.dieselHead), function(diesel, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2",
      attrs: {
        "xs6": ""
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(diesel.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "disable-initial-sort": "",
      "items": _vm.dieselList,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.diesel_nm ? props.item.diesel_nm : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "173px"
          }
        }, [_vm._v(_vm._s(props.item.val ? props.item.val : '-'))])])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_power) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_power) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": _vm.dieselList.length < 4 ? 'pageBreak' : ''
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Water Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("WATER LEVEL (%)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_waterlevel"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waterlevel"
    }
  })])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("CONSUMPTION (KL)")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "div_watercons"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_watercons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subheading pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Total water consumed: " + _vm._s(_vm.lReport.tot_water_cons > 0 ? _vm.lReport.tot_water_cons.toFixed(2) + ' KL' : '0 KL'))])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SOURCES (KL)")])]), _vm._v(" "), _vm._l((_vm.domWatList), function(wat, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "py-2 pl-2",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-left",
      attrs: {
        "xs9": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_type))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-left title",
      attrs: {
        "xs3": ""
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(wat.water_receipt ? wat.water_receipt : 0))])])], 1)], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center mt-2 py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_vm._v("WATER QUALITY & CONTROL")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.paramHead), function(param, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-center py-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(param.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.paramList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-center"
        }, [_c('td', {
          staticClass: "pa-0",
          staticStyle: {
            "font-size": "12px",
            "width": "174px"
          }
        }, [_vm._v(_vm._s(props.item.water_qual))]), _vm._v(" "), _vm._l((props.item.waterQualTypeValue), function(watQualVal, i) {
          return _c('td', {
            key: i,
            class: 'pa-0 ' + (watQualVal.val && (watQualVal.val < watQualVal.stdValMin || watQualVal.val > watQualVal.stdValMax) ? 'red white--text' : (watQualVal.val ? 'green lighten-3' : '')),
            staticStyle: {
              "font-size": "12px",
              "width": "174px"
            }
          }, [_vm._v("\n              " + _vm._s(watQualVal.val ? watQualVal.val : '-') + "\n            ")])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.lReport.remark_water) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_water) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Waste Management")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center",
    attrs: {
      "id": "div_waste"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_waste"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Hygiene Management / Sanity Checks")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("SANITY CHECKS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.hygCats), function(cat, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(cat.check_cat))]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.hygList.filter(function (rec) { return rec.check_cat === cat.check_cat; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pr-0",
            staticStyle: {
              "font-size": "12px",
              "width": "400px"
            }
          }, [_vm._v(_vm._s(props.item.check_desc))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "width": "50px"
            }
          }, [_c('v-checkbox', {
            staticClass: "pt-2",
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: (props.item.check_value),
              callback: function($$v) {
                _vm.$set(props.item, "check_value", $$v)
              },
              expression: "props.item.check_value"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticStyle: {
              "font-size": "12px"
            }
          }, [_vm._v(_vm._s(props.item.remark))])])]
        }
      }], null, true)
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), (_vm.lReport.remark_sanity_checks) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_sanity_checks) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Safety & Security")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("INCIDENTS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.incidentTypes), function(incident, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-left pa-2 primary white--text",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(incident))]), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.incidentList.filter(function (rec) { return rec.incident_type === incident; }),
        "hide-actions": "",
        "disable-initial-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticStyle: {
              "font-size": "12px",
              "width": "315px"
            }
          }, [_vm._v(_vm._s(props.item.incident_class))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_on ? (_vm.handy.formatDate(props.item.incident_on) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_on) + (props.item.incident_end ? ' to ' + _vm.handy.formatDate(props.item.incident_end) + ' ' + _vm.handy.getTime12Hrs(props.item.incident_end) : '') + ' - ' + props.item.incident_desc) : ''))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("52 Week PPM Planner")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("PPM PLANNER")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-top": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lPpmHeader.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.ppmHeader), function(ppm, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-left pa-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(ppm.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.lPpmHeader,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-left"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "162px"
          }
        }, [_vm._v(_vm._s(props.item.asset_tag ? props.item.asset_tag : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "158px"
          }
        }, [_vm._v(_vm._s(props.item.asset_cat ? props.item.asset_cat : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "191px"
          }
        }, [_vm._v(_vm._s(props.item.noneq_name ? props.item.noneq_name : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "164px"
          }
        }, [_vm._v(_vm._s(props.item.freq))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "156px"
          }
        }, [_vm._v(_vm._s(props.item.asset_location ? props.item.asset_location : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(_vm._s(props.item.ppm_status))])])]
      }
    }], null, false, 3576252940)
  })], 1) : _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      NIL\n    ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Complaints & Task Management")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border": "1px solid black"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    staticStyle: {
      "border-right": "1px solid black"
    },
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("COMPLAINTS")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.compHead), function(comp, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "primary white--text text-xs-left pa-2"
    }, [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(comp.text))])])
  }), 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "hide-headers": "",
      "items": _vm.compList,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "text-xs-left"
        }, [_c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.comp_cat))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.prev_pend))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.new_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.reop_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.closed_today))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2",
          staticStyle: {
            "font-size": "12px",
            "width": "139px"
          }
        }, [_vm._v(_vm._s(props.item.closing_bal))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center py-2",
    staticStyle: {
      "font-size": "12px",
      "background-color": "#215868",
      "color": "#fff"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("TASK")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-3 pr-1 text-xs-center",
    attrs: {
      "id": "div_task"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "chart_task"
    }
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Custom Metrics")])]) : _vm._e(), _vm._v(" "), (_vm.lMet.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lMet), function(metric, n) {
    return _c('v-flex', {
      key: n,
      staticClass: "pa-0",
      staticStyle: {
        "border": "1px solid black"
      },
      attrs: {
        "xs3": ""
      }
    }, [(metric) ? _c('div', {
      staticClass: "pa-2 text-xs-center",
      staticStyle: {
        "font-size": "12px",
        "background-color": "#215868",
        "color": "#fff"
      }
    }, [_vm._v("\n        " + _vm._s(metric.metric_cat.toUpperCase()) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "pa-0",
      attrs: {
        "xs12": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.metHead), function(met, i) {
      return _c('v-flex', {
        key: i,
        staticClass: "primary white--text text-xs-center py-2"
      }, [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(met.text))])])
    }), 1)], 1), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "hide-headers": "",
        "items": _vm.metricList.filter(function (rec) { return rec.metric_cat === metric.metric_cat; }),
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "text-xs-center"
          }, [_c('td', {
            staticClass: "px-1",
            staticStyle: {
              "font-size": "12px",
              "width": "130px"
            }
          }, [_vm._v(_vm._s(props.item.metric_nm ? props.item.metric_nm : '-'))]), _vm._v(" "), _c('td', {
            staticClass: "px-1",
            staticStyle: {
              "font-size": "12px",
              "width": "130px"
            }
          }, [_vm._v(_vm._s(props.item.metric_val ? props.item.metric_val : 0))])])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lReport.remark_custom_metrics) ? _c('div', {
    staticClass: "caption pl-1"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v("Remark:")]), _vm._v(" " + _vm._s(_vm.lReport.remark_custom_metrics) + "\n")]) : _vm._e(), _vm._v(" "), (_vm.lReport.major_observ) ? _c('div', {
    staticClass: "caption pa-1"
  }, [_c('div', {
    staticClass: "text-xs-center title py-2 warning--text"
  }, [_vm._v("Major Observation")]), _vm._v(" "), _c('div', {
    staticClass: "pa-1",
    staticStyle: {
      "font-size": "12px",
      "border": "1px solid black"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.handy.getEditorStyle() + _vm.lReport.major_observ)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "id": "pageBreak"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#ff7f2a",
      "font-size": "20px",
      "font-weight": "bold",
      "text-align": "center",
      "padding": "7px 0px"
    }
  }, [_vm._v("Photos")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.lDailyUpdateAttach.files && _vm.lDailyUpdateAttach.files.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.lDailyUpdateAttach.files), function(file, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pa-1 text-xs-center",
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-card-media', {
      staticClass: "black--text caption",
      attrs: {
        "height": "210px",
        "src": file.file_url
      }
    }, [_c('div', {
      staticClass: "white--text",
      staticStyle: {
        "background-color": "rgba(125, 125, 125, 0.5)"
      }
    }, [_vm._v(_vm._s(_vm.handy.formatDBDateTime(file.attach_timestamp))), _c('br'), _vm._v("by " + _vm._s(file.user_name))]), _vm._v(" "), (file.notes) ? _c('div', {
      staticClass: "text-xs-center white--text",
      staticStyle: {
        "position": "absolute",
        "bottom": "0px",
        "width": "100%",
        "background-color": "rgba(0, 0, 255, 0.5)"
      }
    }, [_vm._v("\n          " + _vm._s(file.notes) + "\n        ")]) : _vm._e()])], 1)
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b415ba4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DailyReport.vue
// module id = 764
// module chunks = 31